
import Cardano from "../../../assets/filled/Cardano.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardanoIcon({ className, dataTestid = "CardanoIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Cardano data-testid={dataTestid} className={classes} {...rest} />
  );
}
